var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderOffers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1800 1000",
    style: {
      enableBackground: "new 0 0 1800 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B7A7;}\n\t.st1{fill:#F2F2F2;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1800,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M652.4,524.1h-40l-8.9,25h-19.2l38.3-102h19.5l38.2,102h-19.1L652.4,524.1z M647,508.4l-14.5-41.1L618,508.4 H647z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756.5,510.3v38.8h-17.2v-37.6c0-11.1-6.7-17-14.4-17c-7.8,0-17.6,4.6-17.6,17.9v36.7h-17.2V480h17.2v10.9 c3.6-8.7,14.4-12.7,21.5-12.7C746.6,478.2,756.5,490.2,756.5,510.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M846,480v60.1c0,31.1-15.1,44.5-38.8,44.5c-14.2,0-26.6-7.7-32.7-20.1l14.2-6.5c3.4,6.7,10.9,11.1,18.5,11.1 c13.3,0,21.6-7.5,21.6-27.4v-1.6c-4.9,7.1-14.5,10.8-22.9,10.8c-18.2,0-34-14.4-34-36.4c0-22.2,15.7-36.3,33.9-36.3 c8.9,0,18.2,3.7,23.1,10.8v-9H846L846,480z M828.5,514.3c0-12.1-10.1-20.1-20-20.1c-10.7,0-19.4,8.6-19.4,20.1s8.7,20.6,19.4,20.6 C819.1,534.9,828.5,526.4,828.5,514.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M933.3,520.5h-53.4c1.9,9.6,9.3,14.8,19.5,14.8c7.5,0,14.6-3.3,18.8-8.9l11.4,8.7 c-6.4,10.1-18.5,15.7-31.1,15.7c-20.7,0-36.4-14.8-36.4-36.4c0-22,16.6-36.3,36.3-36.3c19.8,0,35.4,14.1,35.4,35.7 C933.8,515.8,933.6,518,933.3,520.5z M916.6,508.5c-1-9.5-8.3-15.1-17.9-15.1c-9.3,0-16.7,4.6-18.8,15.1H916.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1023.6,514.5c0,22.1-15.8,36.4-34,36.4c-8.3,0-18.2-3.7-22.9-11.1v9.3h-17.2V442.4h17.2v46.8 c4.7-7.4,14.4-11,23.1-11C1007.9,478.2,1023.6,492.2,1023.6,514.5z M1006.5,514.3c0-11.5-8.9-20.1-19.5-20.1c-9.9,0-20,8-20,20.1 c0,12.1,9.5,20.6,20,20.6C997.6,534.9,1006.5,525.8,1006.5,514.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1035.6,514.5c0-21.9,17-36.3,36.7-36.3s36.8,14.4,36.8,36.3c0,21.9-17.2,36.4-36.8,36.4 C1052.6,550.8,1035.6,536.4,1035.6,514.5z M1091.8,514.5c0-11.8-8.9-20.3-19.5-20.3c-10.7,0-19.4,8.4-19.4,20.3 c0,12.1,8.7,20.4,19.4,20.4C1083,534.9,1091.8,526.6,1091.8,514.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1166,
    cy: 569.6,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1285.3,610.2l-72-72c-2.9-2.9-6.9-4.6-11.3-4.6h-56v-40h16v-16h-16v-24h-16v24h-16v16h16.2l-0.2,56v56 c0,4.4,1.8,8.4,4.7,11.4l72,72c2.9,2.9,6.9,4.6,11.3,4.6s8.4-1.8,11.3-4.7l56-56c3-2.9,4.7-6.9,4.7-11.3 C1290,617.2,1288.2,613.1,1285.3,610.2z M1218,677.7l-72-72.1v-56h56v-0.1l72,72L1218,677.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1185.2,618c0,4.6,1.8,8.6,4.8,11.6l28,28l28-28c3-3,4.8-7.1,4.8-11.6c0-9-7.4-16.4-16.4-16.4 c-4.6,0-8.6,1.8-11.6,4.8l-4.8,4.8l-4.8-4.7c-3-3-7.1-4.9-11.6-4.9C1192.6,601.6,1185.2,609,1185.2,618z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderOffers);
export default __webpack_public_path__ + "static/media/placeholder-offers.07c72333bb4334a3a1d6df3be5280f5c.svg";
export { ForwardRef as ReactComponent };